var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-12"},[_c('svg',{attrs:{"width":"102","height":"5"}},[_c('rect',{staticStyle:{"fill":"var(--primary)"},attrs:{"width":"102","height":"5"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }